// https://github.com/Maronato/vue-toastification

import Toast, {useToast} from "vue-toastification";
import "vue-toastification/dist/index.css";

export default {
    install(app) {
        const options = {
            transition: "Vue-Toastification__bounce",
            maxToasts: 20,
            newestOnTop: true,
            position: "top-right",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: true,
            hideProgressBar: false,
            closeButton: "button",
            icon: true,
            rtl: false
        }
        app.use(Toast, options);

        app.config.globalProperties.$toast = useToast();

        app.provide('$toast', app.config.globalProperties.$toast);
    }
}
